module.exports = __webpack_public_path__ + "static/media/Business accounts - SD (2).267abe86.jpg";